<template>
	<div class="cco-reviewCreate" v-if="isOpen">
		<div v-if="!success">
			<div class="review-item post-rating">
				<h3>
					{{ translations['How would you rate this product?'] }}<span>*</span>
				</h3>
				<InteractiveRating v-model="rating"></InteractiveRating>
			</div>
			<div class="review-item description">
				<FieldArea
					:placeholder="translations['Write your review']"
					:id="'description'"
					:required="true"
					v-model="description"
				></FieldArea>
			</div>
			<div class="review-item name" v-if="!cart.customer.isLoggedIn">
				<FieldInput
					:id="'name'"
					:placeholder="translations['Name']"
					:required="true"
					:schema="'text'"
					type="text"
					v-model="name"
				></FieldInput>
			</div>
		</div>

		<div class="actions-wrapper">
			<button
				class="o-btn button"
				@click="postReview"
				v-if="!success"
				:aria-label="translations['Send']"
			>
				<span v-if="!loading">{{ translations['SEND'] }}</span>
				<Loader v-if="loading"></Loader>
			</button>
			<div class="o-btn o-btn--outline failed" v-if="!valid">
				{{ translations['Could not send review'] }}
			</div>
			<div class="success" v-if="success">
				{{ translations['Your review has been sent!'] }}
			</div>
			<a
				class="actions-wrapper__cancel"
				v-if="isOpen && !success"
				@click="this.$emit('changeOpen')"
				>{{ translations['Cancel'] }}</a
			>
			<a
				class="actions-wrapper__cancel"
				v-if="success"
				@click="this.$emit('changeOpen')"
				>Ok</a
			>
		</div>
	</div>
</template>

<script>
//Mixins
import request from '@/vue/mixins/request.js';
import * as map from '@/vue/mixins/map';

import Loader from '../../objects/Loader.vue';
import InteractiveRating from '../../objects/InteractiveRating.vue';
import FieldInput from '../../fields/FieldInput.vue';
import FieldArea from '../../fields/FieldArea.vue';
import FieldCheckbox from '../../fields/FieldCheckbox.vue';

export default {
	name: 'ReviewCreate',
	mixins: [map.site, map.cart, request],
	props: {
		id: {
			type: Number,
			default: 0,
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		//Objects
		Loader,
		InteractiveRating,
		FieldInput,
		FieldArea,
		FieldCheckbox,
	},
	data: () => {
		return {
			valid: true,
			rating: '',
			description: '',
			name: '',
			email: '',

			success: false,
		};
	},
	methods: {
		postReview() {
			const formData = new FormData();
			if (this.rating && this.description) {
				formData.append('action', this.action.postReview);
				formData.append('productId', this.id);
				formData.append('rating', this.rating);
				formData.append('description', this.description);
				formData.append('rememberMe', this.rememberMe);
				if (!this.cart.customer.isLoggedIn) {
					if (this.name) {
						formData.append('name', this.name);
						formData.append('email', this.email);
					} else {
						this.valid = false;
						return;
					}
				}
			} else {
				this.valid = false;
				return;
			}
			this.request(formData).then(() => {
				if (this.res.status == 200) {
					this.success = this.res.data;
					if (this.success) {
						this.valid = true;
					}
				} else {
					this.valid = false;
					this.success = false;
				}
			});
		},
	},
	created() {},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.cco-reviewCreate {
	margin-bottom: 24px;
	.review-item {
		margin: 8px 0;
		span {
			color: $c-red;
		}
	}
	.post-rating {
		border: 1px solid $c-grey;
		border-radius: 1px 1px 0 0;
		border-bottom: none;
		padding: 14px;
		padding-bottom: 12px;
		margin-bottom: 0;
		display: flex;
		justify-content: space-between;
	}
	.description {
		margin-top: 0;
		.o-input {
			margin-top: 0;
			textarea {
				padding-top: 35px;
				border-radius: 0 0 1px 1px;
			}
			label {
				top: 17px;
				font-size: 17px;
			}
		}
		input,
		textarea {
			transition: $t-hover;
			width: 100%;
			padding: 13px 16px;

			border-radius: 2px;
			border: $e-border;
			box-sizing: border-box;

			font-size: $font-base-size;
			line-height: 21px;
			font-weight: $f-semibold;
			color: $c-blue;

			&:focus ~ label,
			&.filled ~ label {
				font-size: $font-disclaimer-size;
				line-height: $font-disclaimer-size;

				top: 10px;
			}

			&:read-only ~ label {
				color: $c-light;
			}
		}
	}
	.save {
		margin-top: -8px;
		margin-bottom: 32px;
	}
	.button {
		min-width: 200px;
	}
	.actions-wrapper {
		display: flex;
		align-items: center;
		.failed {
			border-color: $c-red;
			color: $c-red;
			width: 100%;
			margin-left: 20px;
			&:hover {
				cursor: default;
				background-color: unset;
			}
		}
		&__cancel {
			padding-left: 20px;
			&:hover {
				text-decoration: underline;
				cursor: pointer;
			}
		}
	}
}

@media all and (max-width: 1100px) {
}

@media all and (max-width: 600px) {
}

@media all and (max-width: 450px) {
}
</style>
